export const phonePatternFactory = (mask: string) => {
  const numberBlocks = mask.replaceAll("-", " ").split(" ");
  const pattern = Object.keys(numberBlocks)
    .map((index) => `$${Number(index) + 1}`)
    .join(" ");
  return pattern;
};